import { Grid } from '@mui/material';
import { deleteUserRoleApi, getAllInstUsersApi, getUserByRoleIdAndInstApi, postSaveUserRoleApi } from 'api/user';
import RoleReportingListDialog from 'app/components/Dialog/RoleReportingListDialog';
import RoleUserList from 'app/components/List/RoleUserList';
import LoadingPopUp from 'app/components/LoadingPopup';
import { swal_error } from 'app/utils/appHelpers';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import UserCustomDataTable from '../user/UserCustomDataTable';

const RoleReportingPage = () => {

  const [loading, setLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [reportingUserList, setReportingUserList] = useState([]);
  const [meetingUserList, setMeetingUserList] = useState([]);
  const authUser = useSelector(state => state.auth.authUser);

  const [selectedUser, setSelectedUser] = useState(false);
  const [roleReportingDialogStatus, setRoleReportingDialogStatus] = useState(false);
  const [loadingProcess, setLoadingProcess] = useState(false);


  useEffect(() => {

    const getAPI = async () => {

      setLoading(true)

      const resultMeetingUsers = await getUserByRoleIdAndInstApi(374, "all"); // yk
      setReportingUserList(resultMeetingUsers.data)

      const resultUserList = await getAllInstUsersApi();
      setUserList(resultUserList.data)
      setLoading(false)

    }
    getAPI();
  }, [])


  const handleDeleteRole = async (roleId, user) => {

    Swal.fire({
      title: 'Rol Silme İşlemi',
      text: "Rolü silmek istediğinizden emin misiniz?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet Sil',
      cancelButtonText: "Vazgeç"
    }).then(async (result) => {

      if (result.isConfirmed) {

        const result = await deleteUserRoleApi({ id: user.userRoleId })

        if (result.status) {
          if (roleId === 374) {
            const filteredList = reportingUserList.filter(x => x.userRoleId !== user.userRoleId);
            setReportingUserList(filteredList);

            if (!userList.some(item => item.id === user.id)) {
              setUserList(prevUserList => [user, ...prevUserList]);
            }
          }
        }


        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Silme işlemi başarılı.',
          showConfirmButton: false,
          timer: 1500
        });

      }
    })

  }

  const roleAddCheck = (roleId, user) => {

    if (roleId === 374) {
      const isThere = reportingUserList.some(x => x.id === user.id)
      return isThere
    }


    return false
  }


  const handleCloseRole = async (roleId, inst, unitId = 0) => {
    if (roleId === false || !roleId || roleId === undefined || unitId === null) {
      handleDialogClose();
      return;
    }

    if (roleId !== undefined) {
      if (unitId !== 0) {
        selectedUser.customId = unitId;
      }

      Swal.fire({
        title: 'Rol Ekleme İşlemi',
        text: "Raporlama yetkisi eklemek istediğinizden emin misiniz?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Evet Ekle',
        cancelButtonText: "Vazgeç"
      }).then(async (result) => {
        if (result.isConfirmed) {





          if (roleAddCheck(roleId, selectedUser)) {
            swal_error("Bu rol önceden verilmiş.")
            Swal.close();
            handleDialogClose();
          } else {
            const result = await postSaveUserRoleApi({ userId: selectedUser.id, roleId, inst, customId: unitId, addedUserId: authUser.id, addedDate: new Date() })
            const updatedUser = {
              ...selectedUser,
              roleInst: inst,
              userRoleId: result.userRole.id
            };

            if (result.status) {
              if (roleId === 374) {
                const updatedList = [updatedUser, ...reportingUserList];
                setReportingUserList(updatedList);

                if (meetingUserList.some(x => x.id === updatedUser.id)) {
                  const updatedUserList = userList.filter(user => user.id !== updatedUser.id);
                  setUserList(updatedUserList);
                }
              }
            }

            handleDialogClose();




            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Rol ekleme işlemi başarılı.',
              showConfirmButton: false,
              timer: 1500
            });
          }




        } else {
          handleDialogClose();
        }



      })
    }
  };

  const columnData = [
    { id: 'id', align: 'center', disablePadding: false, label: 'Resim' },
    { id: 'title', align: 'center', disablePadding: true, label: 'Ünvan Ad Soyad' },
    { id: 'islemler', align: 'center', disablePadding: false, label: 'İşlemler' },
  ];

  const handleDialogClose = () => {
    setRoleReportingDialogStatus(false);
  };

  return (
    <>
      <LoadingPopUp open={loading} />
      {!loading && (
        <div>

          <Grid container>
            <Grid container spacing={3.75}>
              <Grid item xs={6} sm={6} lg={6}>
                <UserCustomDataTable
                  mainData={userList}
                  column={columnData}
                  pageTitle="Kullanıcı Listesi"
                  setSelectedUser={setSelectedUser}
                  setRoleDialogStatus={setRoleReportingDialogStatus}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <RoleUserList
                  key={reportingUserList.length}
                  title={'Raporlama Yetki Listesi'}
                  userList={reportingUserList}
                  handleDeleteUser={(user) => handleDeleteRole(374, user)}
                />
              </Grid>
              <Grid item xs={6} sm={6} lg={6}>
                <Grid container spacing={3.75}>

                  <Grid item xs={12} sm={12} lg={12}>
                    <LoadingPopUp open={loadingProcess} />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6}>
                    <RoleReportingListDialog
                      key={reportingUserList.length}
                      pageTitle={'Raporlama Yetki Listesi'}
                      handleCloseRole={handleCloseRole}
                      onClose={() => setRoleReportingDialogStatus(false)}
                      open={roleReportingDialogStatus}
                    />
                  </Grid>

                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </div>
      )}
    </>
  )
}



export default RoleReportingPage
